/* ============================================================
   BOTANILABS — Cart drawer behaviour
   Drives the gram stepper, remove, next-tier bump, cross-sell add
   and promo through the REAL cart API (/cart/change.js, /cart/add.js)
   with Dawn's Section Rendering, then re-renders the drawer via the
   <cart-drawer> element's renderContents(). Kaching's tier discount
   recalculates server-side on every change — nothing is faked here.
   Delegated listeners on document survive the drawer re-render.
   ============================================================ */
(function () {
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var cd = drawer();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // Replace #CartDrawer + the cart icon bubble from a cart API response,
  // with null-guards (Dawn's renderContents throws when a returned section
  // doesn't contain its selector — TypeError on null.innerHTML).
  function manualRender(state) {
    if (!state || !state.sections) return false;
    var did = false;
    try {
      var drawerHTML = state.sections['cart-drawer'];
      if (drawerHTML) {
        var src = new DOMParser().parseFromString(drawerHTML, 'text/html').querySelector('#CartDrawer');
        var dst = document.getElementById('CartDrawer');
        if (src && dst) { dst.innerHTML = src.innerHTML; did = true; }
      }
      var bubbleHTML = state.sections['cart-icon-bubble'];
      if (bubbleHTML) {
        var bdoc = new DOMParser().parseFromString(bubbleHTML, 'text/html');
        var bsrc = bdoc.querySelector('#cart-icon-bubble') || bdoc.querySelector('.shopify-section') || bdoc.body;
        var bdst = document.getElementById('cart-icon-bubble');
        if (bsrc && bdst) bdst.innerHTML = bsrc.innerHTML;
      }
    } catch (e) {
      console.error('[botani-cart] manualRender error', e);
    }
    return did;
  }

  /* ---------- GIFT TIERS (display only) ----------
     Reads the editable tiers JSON (footer group → « Cadeaux par paliers »)
     and the server-rendered subtotal (data-cart-total, fresh on every
     re-render) to draw the progression bar. Adds no product to the cart. */
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtMoney(cents) {
    var v = (parseInt(cents, 10) || 0) / 100;
    try {
      return v.toLocaleString('fr-FR', {
        style: 'currency', currency: 'EUR',
        minimumFractionDigits: v % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    } catch (e) { return v + ' €'; }
  }
  function readJSON(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  /* Cache the (static) gift-tier config. The JSON lives in the footer section,
     but a cart re-render (ours or the gift app's) can momentarily detach it; the
     cache keeps the bar alive so it NEVER blanks out once loaded. */
  var giftTiersCache = null;
  var giftCfgCache = null;
  function giftTiers() {
    var fresh = readJSON('[data-botani-gift-tiers]');
    if (fresh && fresh.length) giftTiersCache = fresh;
    return giftTiersCache || fresh || [];
  }
  function giftConfig() {
    var fresh = readJSON('[data-botani-gift-config]');
    if (fresh) giftCfgCache = fresh;
    return giftCfgCache || fresh || {};
  }
  var GIFT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"/><path d="M12 8l0 13"/><path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"/></svg>';
  var DONE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5l10 -10"/></svg>';

  function renderGiftsInto(box) {
    if (!box) return;
    var tiers = giftTiers().filter(function (t) {
      return t && typeof t.amount === 'number' && t.amount > 0;
    });
    // Only hide if there is genuinely NO tier configured (cache empty too).
    if (!tiers.length) { box.hidden = true; box.innerHTML = ''; return; }
    tiers.sort(function (a, b) { return a.amount - b.amount; });

    var total = parseInt(box.getAttribute('data-cart-total'), 10) || 0;
    var cfg = giftConfig();

    var next = null, prev = 0;
    tiers.forEach(function (t) {
      if (total >= t.amount) { if (t.amount > prev) prev = t.amount; }
      else if (!next || t.amount < next.amount) { next = t; }
    });

    var html;
    if (next) {
      var span = next.amount - prev, into = total - prev;
      var pct = span > 0 ? Math.max(0, Math.min(100, Math.round(into * 100 / span))) : 0;
      var gift = (next.icon ? next.icon + ' ' : '') + (next.label || '');
      html = '<div class="botani-ship__msg">' + GIFT_ICON +
        '<span>' + escapeHtml(cfg.remainingPrefix || 'Plus que') + ' <b>' + fmtMoney(next.amount - total) +
        '</b> ' + escapeHtml(cfg.remainingSuffix || 'pour débloquer') + ' <b>' + escapeHtml(gift) + '</b></span></div>' +
        '<div class="botani-ship__bar"><i style="width:' + pct + '%"></i></div>';
    } else {
      html = '<div class="botani-ship__msg botani-ship__msg--done">' + DONE_ICON +
        '<span>' + escapeHtml(cfg.allUnlocked || 'Tu as débloqué tous les cadeaux 🎁') + '</span></div>' +
        '<div class="botani-ship__bar"><i style="width:100%"></i></div>';
    }

    html += '<div class="botani-gifts__list">' + tiers.map(function (t) {
      var g = (t.icon ? t.icon + ' ' : '') + (t.label || '');
      if (total >= t.amount) return '<span class="botani-gift botani-gift--done">' + escapeHtml(g) + ' 🎉</span>';
      return '<span class="botani-gift">' + escapeHtml(g) + ' · ' + fmtMoney(t.amount) + '</span>';
    }).join('') + '</div>';

    box.innerHTML = html;
    box.hidden = false;
  }

  // Fill EVERY gift-tier box on the page: the drawer's box and, on /cart, the
  // cart page's box (each reads its own data-cart-total). Pages without a box
  // (most) simply iterate zero elements — behaviour unchanged.
  function renderGifts() {
    var boxes = document.querySelectorAll('[data-botani-gifts]');
    for (var i = 0; i < boxes.length; i++) renderGiftsInto(boxes[i]);
  }

  /* renderGifts() only reads data + writes the bar's innerHTML — never the cart
     API, so re-running it on any cart mutation is loop-safe. The flag stops our
     own innerHTML write from re-triggering the observer (the MutationObserver
     callback runs as a microtask, before the setTimeout(0) clears the flag). */
  var renderingGifts = false;
  function renderGiftsSafe() {
    renderingGifts = true;
    try { renderGifts(); } finally {
      setTimeout(function () { renderingGifts = false; }, 0);
    }
  }

  /* The gift app re-renders the cart drawer server-side when it adds/removes the
     gift; that resets our (hidden+empty) bar box and we don't drive it, so the
     bar would vanish until the next manual change. Observe the STABLE
     <cart-drawer> element (it survives even if #CartDrawer's innerHTML or the
     element itself is replaced) and redraw the bar. Display only, no cart write
     → cannot feed the 429 loop. */
  var giftRedrawTimer = null;
  function setupGiftObserver() {
    var cd = drawer();
    if (!cd || !window.MutationObserver) return;
    if (cd.dataset.botaniGiftObs) return; // attach once
    cd.dataset.botaniGiftObs = '1';
    var obs = new MutationObserver(function () {
      if (renderingGifts) return; // ignore our own bar write
      if (giftRedrawTimer) return; // coalesce bursts
      giftRedrawTimer = setTimeout(function () {
        giftRedrawTimer = null;
        renderGiftsSafe();
      }, 30);
    });
    obs.observe(cd, { childList: true, subtree: true });
  }

  function closeDrawer(cd) {
    if (typeof cd.close === 'function') {
      try { cd.close(); return; } catch (e) { /* fall through */ }
    }
    cd.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function openDrawer(cd) {
    cd.classList.remove('is-empty');
    // re-bind overlay close (overlay was replaced inside #CartDrawer on render)
    var ov = document.getElementById('CartDrawer-Overlay');
    if (ov) {
      ov.onclick = function () { closeDrawer(cd); };
    }
    // Open directly — do NOT rely on Dawn's open()/renderContents (fragile).
    cd.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  function renderState(state) {
    var cd = drawer();
    if (!cd) { document.location.reload(); return; }
    manualRender(state); // best-effort content update, never throws (replaces any skeleton)
    renderGiftsSafe(); // redraw the gift-tier bar from the freshly rendered subtotal
    openDrawer(cd); // always open the drawer
  }

  /* Optimistic skeleton: when adding from the product page (drawer closed) or
     when the cart was empty, open the drawer INSTANTLY with a placeholder line
     while /cart/add runs in the background. manualRender() replaces it with the
     real content when the response arrives (~400ms). No cart write here. */
  var SKEL_CLOSE = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  function skelItem() {
    return '<div class="botani-item botani-skel-item">' +
      '<div class="botani-skel botani-skel--media"></div>' +
      '<div class="botani-skel-item__lines">' +
        '<div class="botani-skel botani-skel--line"></div>' +
        '<div class="botani-skel botani-skel--line botani-skel--short"></div>' +
        '<div class="botani-skel botani-skel--line botani-skel--tiny"></div>' +
      '</div></div>';
  }
  function showAddSkeleton(cd) {
    var inner = document.getElementById('CartDrawer');
    if (inner) {
      inner.innerHTML =
        '<div id="CartDrawer-Overlay" class="botani-drawer__overlay"></div>' +
        '<div class="drawer__inner botani-drawer__panel" role="dialog" aria-modal="true" aria-label="Panier" tabindex="-1">' +
          '<header class="botani-drawer__head"><div class="botani-drawer__title"><h2>Ton panier</h2></div>' +
            '<button class="botani-drawer__close drawer__close" type="button" data-botani-skel-close aria-label="Fermer">' + SKEL_CLOSE + '</button>' +
          '</header>' +
          '<div class="botani-items">' +
            '<div class="botani-skel-adding"><span class="botani-spinner"></span>Ajout en cours…</div>' +
            skelItem() + skelItem() +
          '</div>' +
          '<div class="botani-drawer__foot"><div class="botani-skel botani-skel--btn"></div></div>' +
        '</div>';
      var x = inner.querySelector('[data-botani-skel-close]');
      if (x) x.onclick = function () { closeDrawer(cd); };
    }
    openDrawer(cd); // slide in now (removes is-empty, binds overlay close)
  }

  // Failed add (e.g. 429): the skeleton would otherwise stick — fetch the real
  // current cart drawer (read-only GET, no write) and render it over the skeleton.
  function recoverDrawer() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var dst = document.getElementById('CartDrawer');
        if (src && dst) { dst.innerHTML = src.innerHTML; renderGiftsSafe(); }
      })
      .catch(function () { /* leave drawer; user can close */ });
  }

  function busy(on) {
    var cd = drawer();
    if (cd) cd.classList.toggle('botani-loading', !!on);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (r.status === 429) {
        // rate-limited (typically the free-gift app + us racing) — back off,
        // do NOT retry (retrying would feed the loop). Surface a soft error.
        var err = new Error('cart-rate-limited-429');
        err.code = 429;
        throw err;
      }
      return r.json();
    });
  }

  /* ---------- Anti-loop cart writer ----------
     A free-gift app adds/removes a gift line whenever the cart crosses a
     threshold. It observes cart mutations; our drawer re-renders on every
     response. Left unguarded, our writes and the app's writes stack into
     overlapping /cart/change calls and trip Shopify's 429 rate limit, freezing
     the cart. Three guards keep the THEME from amplifying that:
       1. isUpdatingCart re-entrancy lock → only ONE of our cart writes is ever
          in flight; the render that follows a change issues no further write.
       2. A serial FIFO queue → distinct ops (e.g. two different add buttons)
          still run, but sequentially, never concurrently.
       3. Per-line debounce on quantity changes → rapid +/- (or the app
          bouncing the cart) collapse into a single request after ~350ms. */
  var isUpdatingCart = false;
  var cartQueue = [];
  var pendingQty = {}; // line -> { quantity, timer }
  // Only used to COALESCE rapid +/- on the same line. The real 429 guard is the
  // single-in-flight FIFO queue, not this delay — so keep it short for snappiness.
  var DEBOUNCE_MS = 200;

  function drainQueue() {
    if (!cartQueue.length) { isUpdatingCart = false; busy(false); return; }
    isUpdatingCart = true;
    busy(true);
    var op = cartQueue.shift();
    Promise.resolve()
      .then(op) // op() returns a Promise resolving to cart state
      .then(function (state) { if (state) renderState(state); })
      .catch(function (e) { console.error('[botani-cart]', e && e.message ? e.message : e); })
      .finally(function () { drainQueue(); }); // serialize: next op only after this one settles
  }

  // Queue a cart-write thunk (must return a Promise resolving to cart state).
  function enqueue(opFn) {
    cartQueue.push(opFn);
    if (!isUpdatingCart) drainQueue();
  }

  function doChange(line, quantity) {
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    return postJSON(url, {
      line: line, quantity: quantity,
      sections: sectionIds(), sections_url: window.location.pathname,
    });
  }
  function doAdd(id, quantity) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return postJSON(url, {
      items: [{ id: Number(id), quantity: parseInt(quantity, 10) || 1 }],
      sections: sectionIds(), sections_url: window.location.pathname,
    });
  }

  // Public entry point: quantity change — debounced per line, then serialized.
  function changeLine(line, quantity) {
    var existing = pendingQty[line];
    if (existing && existing.timer) clearTimeout(existing.timer);
    pendingQty[line] = {
      quantity: quantity,
      timer: setTimeout(function () {
        var q = pendingQty[line].quantity;
        delete pendingQty[line];
        enqueue(function () { return doChange(line, q); });
      }, DEBOUNCE_MS),
    };
    busy(true); // instant feedback; cleared when the queue drains
  }

  // Immediate change (no debounce) for discrete one-shot actions: remove, bump.
  // Still serialized through the FIFO queue, so the anti-429 guarantee holds.
  function changeLineNow(line, quantity) {
    var existing = pendingQty[line];
    if (existing && existing.timer) { clearTimeout(existing.timer); delete pendingQty[line]; }
    enqueue(function () { return doChange(line, quantity); });
  }

  /* ---------- Optimistic UI (display only, no network) ----------
     Reflect the action in the DOM the instant it's clicked, so the drawer feels
     live during the request. The authoritative server re-render (renderState)
     overwrites this a moment later — these helpers never touch the cart API. */
  function setLineQty(line, qty) {
    var item = document.querySelector('.botani-item[data-line="' + line + '"]');
    if (!item) return;
    var val = item.querySelector('.botani-stepper__val');
    // Unité d'affichage posée en Liquid (« g » pour Fleur/Résine, vide sinon).
    var unit = item.getAttribute('data-unit');
    if (val) val.innerHTML = qty + (unit ? '<small>' + unit + '</small>' : '');
    var btns = item.querySelectorAll('[data-cart-plus],[data-cart-minus]');
    Array.prototype.forEach.call(btns, function (b) { b.setAttribute('data-qty', qty); });
  }
  function fadeLineOut(line) {
    var item = document.querySelector('.botani-item[data-line="' + line + '"]');
    if (item) { item.style.opacity = '0.35'; item.style.pointerEvents = 'none'; }
  }

  // Public entry point: add a product — distinct products must NOT be dropped,
  // so they queue (serialized) rather than debounce-coalesce.
  function addItem(id, quantity) {
    var cd = drawer();
    if (cd) {
      var alreadyOpenWithItems = cd.classList.contains('active') && !cd.classList.contains('is-empty');
      if (alreadyOpenWithItems) {
        // cross-sell inside an open, populated drawer: keep content visible
        busy(true);
      } else {
        // product page (drawer closed) OR empty cart: open INSTANTLY with a
        // skeleton — works whether the cart was empty or not.
        showAddSkeleton(cd);
      }
    }
    return new Promise(function (resolve) {
      enqueue(function () {
        return doAdd(id, quantity).then(
          function (state) { resolve(state); return state; },
          function (e) { resolve(null); throw e; }
        );
      });
    }).then(function (state) {
      if (!state) recoverDrawer(); // add failed → restore real cart over the skeleton
      return state;
    });
  }

  // Exposed so the product page (and any custom UI) can add through the
  // same proven path that opens & re-renders the drawer.
  window.BotaniCart = {
    add: addItem,
    change: changeLine,
    refreshGifts: renderGiftsSafe,
    open: function () { var c = drawer(); if (c && typeof c.open === 'function') c.open(); },
  };

  document.addEventListener('click', function (e) {
    // The cart PAGE has its own handler (botani-cart-page.js). Never drive the
    // drawer from a click inside it — that would force the drawer open.
    if (e.target.closest && e.target.closest('[data-botani-cart-page]')) return;
    var minus = e.target.closest('[data-cart-minus]');
    var plus = e.target.closest('[data-cart-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    var bump = e.target.closest('[data-cart-bump]');
    var csAdd = e.target.closest('[data-cart-add]');
    var promo = e.target.closest('[data-cart-promo]');

    if (minus) {
      // base on the pending (debounced) value if any, else the rendered qty —
      // so rapid clicks accumulate instead of being lost before the re-render
      var lineM = parseInt(minus.getAttribute('data-line'), 10);
      var baseM = pendingQty[lineM] ? pendingQty[lineM].quantity : (parseInt(minus.getAttribute('data-qty'), 10) || 1);
      var nextM = Math.max(1, baseM - 1);
      setLineQty(lineM, nextM); // instant visual feedback
      changeLine(lineM, nextM);
    } else if (plus) {
      var lineP = parseInt(plus.getAttribute('data-line'), 10);
      var baseP = pendingQty[lineP] ? pendingQty[lineP].quantity : (parseInt(plus.getAttribute('data-qty'), 10) || 1);
      var nextP = baseP + 1;
      setLineQty(lineP, nextP); // instant visual feedback
      changeLine(lineP, nextP);
    } else if (remove) {
      var lineR = parseInt(remove.getAttribute('data-line'), 10);
      fadeLineOut(lineR); // instant visual feedback
      changeLineNow(lineR, 0); // no debounce for a discrete remove
    } else if (bump) {
      var lineB = parseInt(bump.getAttribute('data-line'), 10);
      var targetB = parseInt(bump.getAttribute('data-target'), 10);
      setLineQty(lineB, targetB); // instant visual feedback
      changeLineNow(lineB, targetB); // no debounce for a discrete bump
    } else if (csAdd) {
      addItem(csAdd.getAttribute('data-id'));
    } else if (promo) {
      var input = document.getElementById('BotaniPromo');
      var code = input && input.value ? input.value.trim() : '';
      if (code) {
        // Shopify applies a discount code via /discount/{code}; it persists to checkout.
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      }
    }
  });

  // Enter key in the promo field
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.id === 'BotaniPromo') {
      e.preventDefault();
      var btn = document.querySelector('[data-cart-promo]');
      if (btn) btn.click();
    }
  });

  // Initial draw of the gift-tier bar + observer (drawer is server-rendered).
  function initGifts() {
    renderGiftsSafe();
    setupGiftObserver();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGifts);
  } else {
    initGifts();
  }
  document.addEventListener('shopify:section:load', initGifts);
})();
